import { Pipe, PipeTransform } from '@angular/core';
import { StatusPainelDeAtendimento as Status } from '../../enum/StatusAtendimento';

@Pipe({
  name: 'statusPainelDeAtendimento',
})
export class StatusPainelDeAtendimentoPipe implements PipeTransform {
  transform(status: Status): string {
    return {
      [Status.Aberto]: 'Aberto',
      [Status.Fechado]: 'Fechado',
    }[status];
  }
}
